import React from 'react';
import { connect } from 'react-redux';

import Pagination from './Pagination';


function IntroPagination({ currentAssessment, putAssessment, questions, navigate }) {
  const urlPrefix = '/assessments/' + currentAssessment.id + '/';
  if (!questions) return null;
  const questionsLength = Object.keys(questions).length;
  return (
    <div className="new-assessment-detail__pagination-wrapper">
      <Pagination
        prevUrl={urlPrefix + 'preface'}
        nextUrl={urlPrefix + '1'}
        textDisabled
        questionNumber={1}
        totalQuestions={questionsLength}
        putAssessment={putAssessment}
        navigate={navigate}
        currentAssessmentId={currentAssessment.id}
      />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    questions: state.sections[state.assessments.currentAssessment.section].questions,
    currentAssessment: state.assessments.currentAssessment,
  };
}

export default connect(mapStateToProps)(IntroPagination);



// WEBPACK FOOTER //
// ./src/components/features/assessment/IntroPagination.js